export const getExtionsionlessGalleryName = (fileName: string) => {
  const index = fileName.lastIndexOf('.')
  if (index === -1) {
    return fileName
  }
  return fileName.substring(0, index)
}
